<template>
  <div class="card">
    <div class="card-body" style="min-height: 22rem">
      <div class="clearfix">
        <div class="d-flex justify-content-between">
          <h4 class="card-title mb-4">Orders for Delivery</h4>
          <div class="button-items mb-2" v-if="ordersForDeliveryReport.objects.length > 0">
            <button v-if="loading" size="sm" class="btn btn-dark py-1" :disabled="loading">Loading</button>
            <span v-else>
              <b-button variant="info" size="sm" class="py-1 text-white" v-if="generate_ordersinvoice" @click="generateInvoices">
                Generate Invoices
              </b-button>
            </span>
            <button v-if="deliveryLoading" size="sm" class="btn btn-dark py-1" :disabled="deliveryLoading">Loading</button>
            <span v-else>
              <b-button variant="danger" size="sm" class="py-1 text-white" v-if="generate_ordersdeliverynote" @click="generateDeliveryNotes">
              Generate Delivery Notes
            </b-button>
            </span>

          </div>
        </div>
        <div class="d-flex justify-content-between">
          <div class="flex d-inline-flex my-2 " style="width: 30%">
            <label class="input-group-text bg-primary text-white">Warehouses</label>
            <multiselect v-model="warehouse" :options="warehouses.objects" open-direction="top"
                         placeholder="Select one" label="name" track-by="name" :searchable="true" multiple>
              <span slot="noResult">No warehouse found. Change search query.</span>
            </multiselect>
          </div>
          <div class="float-end">
            <div class="flex-nowrap input-group input-group-sm mb-3">
              <label class="input-group-text bg-light">Date</label>
              <date-picker v-model="ordersDeliveryDateSelected" class="dashboard-datepicker" fixed-position="top-right" @input="ordersDeliveryDateSelectedFn"></date-picker>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-4" />
      <div>
        <data-table :columns="ordersForDeliveryColumns" :rows="ordersForDeliveryReport.objects" :has-pagination="false" :has-search="false">
          <template v-slot:actions="slotProps" v-if="isToday">
            <div v-if="slotProps.row.availableStatusChanges.length > 0 && checkForPermission(change_order_status_permission)">
              <select :id="slotProps.row.publicId" @change="changeStatus($event, slotProps.row.publicId)" class="dashboard-order-select">
                <option selected></option>
                <option v-for="status in slotProps.row.availableStatusChanges" :value="status.publicId" :key="status.publicId">{{ status.orderStatusName }}</option>
              </select>
            </div>
          </template>
        </data-table>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";
import {ALL_WAREHOUSES, ORDERS_DUE_FOR_DELIVERY_ON_A_DAY} from "@/gql";
import moment from "moment";
import {permissions} from "@/router/permissions";
import {mapActions} from "vuex";
import {errorToast, successToast} from "@/components/successToast";
import {downloadFileConfig} from "@/filters/downloadFileConfig";
import Multiselect from "vue-multiselect";
export default {
  name: "OrdersForDelivery",
  components: {DataTable, Multiselect},
  data(){
    return {
      ordersDeliveryDateSelected: new Date(),
      ordersForDeliveryColumns: [
        {
          field: 'salesCustomer',
          label: 'Customer'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'grossOrderTotal',
          label: 'Total'
        },
        {
          field: 'orderStatus',
          label: 'Order Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      ordersForDeliveryReport: {
        page: 0,
        objects: []
      },
      warehouses: {
        objects: []
      },
      warehouse: '',
      selectedWarehouse: [],
      loading: false,
      deliveryLoading: false,
      currentPage: 1,
      perPage: 30,
      deliveryDates: [moment().format('YYYY-MM-DD')],
      selectedStatus: '',
      change_order_status_permission: permissions.change_order_status_permission,
      generate_ordersinvoice: permissions.generate_ordersinvoice,
      generate_ordersdeliverynote: permissions.generate_ordersdeliverynote
    }
  },
  apollo: {
    ordersForDeliveryReport: {
      query: ORDERS_DUE_FOR_DELIVERY_ON_A_DAY,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          deliveryDates: this.deliveryDates,
          warehouses: this.selectedWarehouse
        }
      }
    },
    warehouses: {
      query: ALL_WAREHOUSES,
      variables(){
        return {
          page: 0,
          perPage: 30,
          isActive: true,
        }
      }
    }
  },
  computed: {
    isToday(){
      return this.deliveryDates[0] === moment().format('YYYY-MM-DD')
    },
  },
  watch: {
    warehouse(){
      this.warehouseSelect()
    }
  },
  methods: {
    ... mapActions({
      changeOrderStatus: 'orders/changeOrderStatus',
      generateBatchOrderInvoices: 'http/generateBatchOrderInvoices',
      generateBatchOrderDeliveryNotes: 'http/generateBatchOrderDeliveryNotes',
    }),
    warehouseSelect(){
      const warehouses = []
      this.warehouse.forEach((warehouse)=> {
        warehouses.push(warehouse.publicId)
      })
      this.selectedWarehouse = warehouses
    },
    ordersDeliveryDateSelectedFn(){
      this.deliveryDates = [moment(this.ordersDeliveryDateSelected).format('YYYY-MM-DD')]
    },
    async changeStatus(event, orderId){
      const data = {orderId: orderId ,statusId: event.target.value}
      await this.changeOrderStatus(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.ordersForDeliveryReport.refetch()
        }
      })
    },
    getOrderPublicIds(){
      const orders = this.ordersForDeliveryReport.objects
      let orderIds = []
      orders.forEach((order)=>{
        orderIds.push(order.publicId)
      })
      return orderIds
    },
    async generateInvoices(){
      this.loading = true
      const ids = this.getOrderPublicIds()
      const response = await this.generateBatchOrderInvoices(ids)
      if(response.data.type === "application/pdf"){
        downloadFileConfig(response, `Orders For Delivery ${this.deliveryDates} - Invoices.pdf`)
      }else {
        errorToast('Error generating order invoices')
      }
      this.loading = false
    },
    async generateDeliveryNotes(){
      this.deliveryLoading = true
      const ids = this.getOrderPublicIds()
      const response = await this.generateBatchOrderDeliveryNotes(ids)
      if(response.data.type === "application/pdf"){
        downloadFileConfig(response, `Orders For Delivery ${this.deliveryDates} - DeliveryNotes.pdf`)
      }else {
        errorToast('Error generating order delivery notes')
      }
      this.deliveryLoading = false
    }
  }
}
</script>

<style scoped>

</style>
